module.exports = __webpack_public_path__ + "img/v4_transferTool_h.69febf60.png";